import React, { useState, useRef, useEffect } from 'react'
import '../AdminCommonCom/Header.css'
import { CgProfile } from 'react-icons/cg'
import { AiOutlineLogout } from 'react-icons/ai'
import { RiLockPasswordFill } from 'react-icons/ri'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { BranchMaster } from '../../../AllAPI/AdminAPI'
import hostelLogo from '../../../Assets/logo.png'
import { ChangePassword } from '../../../AllAPI/StudentAPI'
import { Button, Input, Modal } from 'antd'
import { toast } from 'react-toastify'

export default function StudentHeader({ toggleSidebar, onLogout }) {
  const stored = sessionStorage.getItem('studentData')
  const studentData = stored ? JSON.parse(stored) : null

  const Status = studentData?.status
  const BranchId = studentData.branch_id
  const UserName = studentData.fullName

  const [branchName, setBranchName] = useState('')

  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [showLogoutModal, setShowLogoutModal] = useState(false)
  const dropdownRef = useRef(null)
  const navigate = useNavigate()

  const [showPasswordModal, setShowPasswordModal] = useState(false)
  const [oldPass, setOldPass] = useState('')
  const [newPass, setNewPass] = useState('')
  const [confirmPass, setConfirmPass] = useState('')
  const [errorMsg, setErrorMsg] = useState('')
  const [loading, setLoading] = useState(false)


  const handlePasswordSubmit = async () => {
  setErrorMsg("");

  if (!oldPass || !newPass || !confirmPass) {
    setErrorMsg("All fields are required");
    return;
  }

  if (newPass.length < 4) {
    setErrorMsg("New password must be at least 4 characters");
    return;
  }

  if (newPass !== confirmPass) {
    setErrorMsg("New password & Confirm password do not match");
    return;
  }

  try {
    setLoading(true);

    const payload = {
      reg_id: studentData.reg_id,  
      password: oldPass,
      newPassword: newPass,
    };

    const res = await axios.post(ChangePassword, payload);
    if (res.data == "NOTMATCH") {
      toast.warn("Old password is incorrect!");
    }
    else if (res.data == "NOTFOUND") {
      toast.warn("Member not found!");
    }
    else if (res.data == "PASSWORDCHANGE") {
      toast.success("Password updated successfully!");
       // Close modal
      setShowPasswordModal(false);

      setOldPass("");
      setNewPass("");
      setConfirmPass("");
    }

  } catch (error) {
    setErrorMsg(error.response?.data?.message || "Something went wrong, Please try again later!");
  } finally {
    setLoading(false);
  }
};


  const toggleDropdown = (e) => {
    e.stopPropagation()
    setDropdownOpen((prev) => !prev)
  }

  // ✅ Improved outside click detection
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false)
      }
    }
    document.addEventListener('click', handleClickOutside)
    return () => document.removeEventListener('click', handleClickOutside)
  }, [])

  const handleLogoutClick = (e) => {
    e.stopPropagation()
    setShowLogoutModal(true)
    setDropdownOpen(false)
  }

  const confirmLogout = () => {
    setShowLogoutModal(false)
    onLogout()
    navigate('/student/login')
    // ✅ Clear all storage
    sessionStorage.clear()
    localStorage.clear()
  }

  const cancelLogout = () => setShowLogoutModal(false)

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const response = await axios.get(`${BranchMaster}`)
        const branches = response.data

        // find matching branch
        const matched = branches.find(
          (item) => String(item.branch_id) === String(BranchId),
        )

        if (matched) {
          setBranchName(matched.branch_name)
        }
      } catch (err) {
        console.error('Error fetching branches:', err)
      }
    }

    fetchBranches()
  }, [BranchId])

  return (
    <>
      <header className="header shadow">
        <div className="desktop-grid border">
          {/* Hide Sidebar Toggle if status = 0,1 or 3 */}
          {![0, 1, 3].includes(Status) && (
            <button
              className="menu-btn"
              onClick={toggleSidebar}
              aria-label="menu"
            >
              ☰
            </button>
          )}
           {[0, 1, 3].includes(Status) && (
            <button className="menu-btn"></button>
           )}

          <div className="desktop-center">
            <span className="header-title">
              <img src={hostelLogo} alt="Hostel Logo" className="hostel-logo" />
              {branchName}
            </span>
          </div>

          <div className="profile-container" ref={dropdownRef}>
            <span style={{ color: '#737070ff' }}>
              Hi, {UserName?.toUpperCase()} &nbsp;
            </span>
            <CgProfile className="profile border" onClick={toggleDropdown} />
            {dropdownOpen && (
              <div className="profile-dropdown slide-in">
                <button className="dropdown-item" onClick={() => setShowPasswordModal(true)}>
                  <RiLockPasswordFill /> Change Password
                </button>

                <button className="dropdown-item" onClick={handleLogoutClick}>
                  <AiOutlineLogout /> Logout
                </button>
              </div>
            )}
          </div>
        </div>

        {/* ===== Mobile ===== */}
        <div className="mobile-header">
          <div className="mobile-center">
            <span className="mobile-title">
              <img src={hostelLogo} alt="Hostel Logo" className="hostel-logo" />{' '}
              {branchName}
            </span>
          </div>

          <div className="mobile-bottom" ref={dropdownRef}>
           {![0, 1, 3].includes(Status) && (
            <button className="menu-btn" onClick={toggleSidebar}>
              ☰
            </button>
           )}
           {[0, 1, 3].includes(Status) && (
            <button className="menu-btn"></button>
           )}
            <div className="profile-container">
              <span style={{ color: '#b5b5b5ff' }}>
                Hi, {UserName?.toUpperCase()} &nbsp;
              </span>
              <CgProfile className="profile border" onClick={toggleDropdown} />
              {dropdownOpen && (
                <div className="profile-dropdown slide-in">
                  <button className="dropdown-item" onClick={() => setShowPasswordModal(true)}>
                    <RiLockPasswordFill /> Change Password
                  </button>
                  <button className="dropdown-item" onClick={handleLogoutClick}>
                    <AiOutlineLogout /> Logout
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      {/* ===== Logout Confirmation ===== */}
      {showLogoutModal && (
        <>
          <div className="logout-overlay" onClick={cancelLogout}></div>
          <div className="logout-modal">
            <h2>Confirm Logout</h2>
            <p>Are you sure you want to logout?</p>
            <div className="modal-buttons">
              <button className="btn-cancel" onClick={cancelLogout}>
                Cancel
              </button>
              <button className="btn-confirm" onClick={confirmLogout}>
                OK
              </button>
            </div>
          </div>
        </>
      )}

      {/* ===== Change Password ===== */}
          <Modal
            title="Change Password"
            open={showPasswordModal}
            onCancel={() => setShowPasswordModal(false)}
            footer={null}
            centered
            style={{
              borderRadius: 10,
              padding: 0,
            }}
            bodyStyle={{
              padding: "20px 25px",
              borderRadius: 10,
            }}
          >
            {errorMsg && (
              <div
                style={{
                  background: "#ffe1e1",
                  padding: "8px 12px",
                  marginBottom: 15,
                  borderRadius: 6,
                  color: "#b30000",
                  fontSize: 14,
                }}
              >
                {errorMsg}
              </div>
            )}

            <div style={{ marginBottom: 15 }}>
              <label style={{ fontWeight: 600 }}>Old Password</label>
              <Input.Password
                value={oldPass}
                onChange={(e) => setOldPass(e.target.value)}
                placeholder="Enter old password"
                style={{
                  marginTop: 5,
                  padding: 8,
                  borderRadius: 6,
                }}
              />
            </div>

            <div style={{ marginBottom: 15 }}>
              <label style={{ fontWeight: 600 }}>New Password</label>
              <Input.Password
                value={newPass}
                onChange={(e) => setNewPass(e.target.value)}
                placeholder="Enter new password"
                style={{
                  marginTop: 5,
                  padding: 8,
                  borderRadius: 6,
                }}
              />
            </div>

            <div style={{ marginBottom: 20 }}>
              <label style={{ fontWeight: 600 }}>Confirm Password</label>
              <Input.Password
                value={confirmPass}
                onChange={(e) => setConfirmPass(e.target.value)}
                placeholder="Re-enter new password"
                style={{
                  marginTop: 5,
                  padding: 8,
                  borderRadius: 6,
                }}
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 10,
              }}
            >
              <Button onClick={() => setShowPasswordModal(false)}>Cancel</Button>

              <Button
                type="primary"
                loading={loading}
                onClick={handlePasswordSubmit}
                style={{ background: "#1677ff" }}
              >
                Update
              </Button>
            </div>
          </Modal>


    </>
  )
}
